export type Sex = 'MALE' | 'FEMALE' | 'OTHER';
export const SEX_VALUES = ['MALE', 'FEMALE', 'OTHER'];

export const toSex = (value: string): Sex => {
  if (value === 'MALE' || value === 'FEMALE' || value === 'OTHER') {
    return value;
  }

  throw new Error();
};

class UserPersonalInformation {
  public readonly lastName: string;
  public readonly firstName: string;
  public readonly nationality: string;
  public readonly sex: Sex;
  public readonly birthdate: string | null;
  public readonly freezed: boolean;

  constructor({
    lastName,
    firstName,
    nationality,
    sex,
    birthdate,
    freezed,
  }: {
    lastName: string;
    firstName: string;
    nationality: string | null;
    sex: Sex | null;
    birthdate: string | null;
    freezed: boolean;
  }) {
    this.lastName = lastName;
    this.firstName = firstName;
    this.nationality = nationality || 'JP';
    this.sex = sex || 'OTHER';
    this.birthdate = birthdate;
    this.freezed = freezed;
  }

  public static fromJSON = (v: any) => {
    const { lastName, firstName, nationality, sex, birthdate, freezed } = Object.assign({}, v);

    if (typeof lastName !== 'string') throw new TypeError('.lastName must be a string');
    if (typeof firstName !== 'string') throw new TypeError('.firstName must be a string');
    if (typeof nationality !== 'string') throw new TypeError('.nationality must be a string');

    if (new Date(Date.parse(birthdate)).toString() === 'Invalid Date')
      throw new TypeError('.birthdate must be a date string');

    return new UserPersonalInformation({
      lastName,
      firstName,
      nationality,
      sex,
      birthdate,
      freezed,
    });
  };
}

export default UserPersonalInformation;
